import { useState } from "react";
import { Link } from "react-router-dom";
import { Info, HelpCircle, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HELP } from "@/lib/help";

export const SectionHelp = ({ id, className = "" }) => {
  const h = HELP[id];
  const [open, setOpen] = useState(false);
  if (!h) return null;
  return (
    <div className={`mb-5 rounded-lg border border-sky-200 bg-sky-50/60 px-4 py-3 text-sm text-slate-700 ${className}`} data-testid={`section-help-${id}`}>
      <div className="flex items-start gap-2"><Info className="mt-0.5 h-4 w-4 shrink-0 text-sky-700" /><span className="flex-1">{h.text}</span>
        {(h.example || h.learn) && <button onClick={() => setOpen(!open)} className="flex shrink-0 items-center gap-0.5 text-xs font-medium text-sky-800 hover:underline" data-testid={`section-help-toggle-${id}`}>
          Example<ChevronDown className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`} /></button>}</div>
      {open && <div className="mt-2 pl-6 text-xs text-slate-600"><b>Example:</b> {h.example} {h.learn && <Link to={h.learn} className="ml-1 font-medium text-sky-800 underline">Learn more</Link>}</div>}
    </div>
  );
};

export const InfoTip = ({ text, example, testId }) => (
  <Popover>
    <PopoverTrigger asChild><button type="button" aria-label="More information" className="inline-flex align-middle text-slate-400 hover:text-blue-600" data-testid={testId}><HelpCircle className="h-3.5 w-3.5" /></button></PopoverTrigger>
    <PopoverContent className="w-72 text-xs leading-relaxed text-slate-700">{text}{example && <div className="mt-1.5 text-slate-500"><b>Example:</b> {example}</div>}</PopoverContent>
  </Popover>
);
